import script from "./SelectOptionV2.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectOptionV2.vue?vue&type=script&setup=true&lang=js"

import "./SelectOptionV2.vue?vue&type=style&index=0&id=74578470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74578470"]])

export default __exports__